import { ProgressBar } from '../../ds';
import { primaryBtn, screenShell } from './common';
import { LoadingState } from '../../components/ScreenState';
import { useAsync } from '../../hooks/useAsync';
import { contentApi } from '../../api/content';
import { progressApi } from '../../api/progress';
import type { LessonStepParams } from './types';

const Star = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="var(--ember-dark)">
    <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.7 7-6.3-3.9L5.7 21l1.7-7L2 9.2l7.1-.6z" />
  </svg>
);

interface Props extends LessonStepParams {
  onBackToMap: () => void;
}

export function CompleteScreen({ lessonId, lessonName, onBackToMap }: Props) {
  const lesson = useAsync(() => contentApi.getLesson(lessonId), [lessonId]);
  // Gọi ngay khi màn Complete mở ra — đây LÀ hành động "hoàn thành lesson":
  // ghi UserLessonProgress, cộng XP/streak, tạo thẻ SRS. Xem progress.service.ts#completeLesson.
  const completion = useAsync(() => progressApi.completeLesson(lessonId), [lessonId]);

  const chips = lesson.data?.items
    .slice(0, 8)
    .map((it) => (it.itemType === 'VOCAB' ? it.kanji ?? it.kana : it.itemType === 'GRAMMAR' ? it.title : it.character));

  return (
    <div style={screenShell}>
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20, padding: 32 }}>
        <div style={{ width: 76, height: 76, borderRadius: '50%', background: 'var(--success-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width={34} height={34} viewBox="0 0 24 24" fill="none" stroke="var(--success)" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <h1 style={{ fontSize: 23, fontWeight: 700, color: 'var(--ink)', textAlign: 'center', margin: 0, lineHeight: 1.3 }}>{`Hoàn thành ${lessonName}!`}</h1>

        {lesson.loading ? (
          <LoadingState />
        ) : chips && chips.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
            {chips.map((label, i) => (
              <div
                key={i}
                style={{
                  minWidth: 56,
                  height: 56,
                  padding: '0 10px',
                  borderRadius: 'var(--radius-control)',
                  border: '2px solid var(--success)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'var(--font-jp)',
                  fontSize: 17,
                  fontWeight: 500,
                  color: 'var(--ink)',
                }}
              >
                {label}
              </div>
            ))}
          </div>
        ) : null}

        <div style={{ width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              background: 'rgba(242,128,59,0.16)',
              color: 'var(--ember-dark)',
              fontSize: 20,
              fontWeight: 700,
              padding: '8px 18px',
              borderRadius: 999,
            }}
          >
            <Star />
            {completion.loading ? '···' : `+${completion.data?.xpAwarded ?? 0} XP`}
          </div>
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>
              <span>{`Level ${completion.data?.level ?? 1}`}</span>
              <span>{`${completion.data?.xpIntoLevel ?? 0} / ${completion.data?.xpForNextLevel ?? 100} XP`}</span>
            </div>
            <ProgressBar value={completion.data?.xpIntoLevel ?? 0} max={completion.data?.xpForNextLevel ?? 100} tone="ember" />
          </div>
        </div>
      </div>

      <div style={{ padding: 20, borderTop: '1px solid var(--border-default)' }}>
        <button onClick={onBackToMap} style={primaryBtn}>
          Về lộ trình
        </button>
      </div>
    </div>
  );
}
